import T from '../i18n/content.js';
import { useT } from '../i18n/LangContext.jsx';

export default function Founder({ asPage = false }) {
  const t = useT();
  const S = T.founderSec;
  const F = T.founder;

  return (
    <section className={`section founder ${asPage ? 'founder--page' : ''}`}>
      <div className="wrap">
        {!asPage && (
          <header className="section__head">
            <div>
              <div className="kicker">
                <span className="label">{t(S.kicker)}</span>
                <span className="bronze-rule" />
              </div>
              <h2>{t(S.pageTitle)}</h2>
            </div>
            <p className="lede">{t(S.lede)}</p>
          </header>
        )}
        <div className="founder__layout">
          <header className="founder__head">
            <div className="founder__name">{t(F.name)}</div>
            <span className="founder__rule" />
            <div className="founder__role">{t(F.role)}</div>
          </header>
          <div className="founder__body">
            <div className="founder__desc">
              {t(F.bio).split('\n\n').map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
